/* eslint-disable */
// import axios from "fetch-api/fetch-api";
import { getDiameterByWidthProfile } from "api/garage/getDiameterByWidthProfile";
import { getProfileByWidth } from "api/garage/getProfileByWidth";
import { getTiresWidth } from "api/garage/getTiresWidth";
import { useTranslation } from "next-i18next";
import { useRef, useState, useEffect } from "react";
import { buildTireSize } from "../../util/helper/buildTireSize";
import HideIf from "../../util/HideIf";
import PAButton, { BUTTON_TYPE } from "../design-system/buttons/PAButton";
import BoxedSelector from "./styles/BoxedSelector";
import VehicleSelect from "./VehicleSelectComponent";

function transform(data: any) {
  return [{ options: data.map((_: any) => ({
    label: _,
    value: _
  })) }];
}

const defaultSelectedTireSize = {
  width: undefined,
  profile: undefined,
  diameter: undefined,
}

const defaultIsLoading = {
  width: true,
  profile: false,
  diameter: false,
}

function BoxedTierSelector(props: any) {
  const { handleSizeSelect, calculateSize } = props;
  const [selectedTireSize, setSelectedTireSize] = useState(defaultSelectedTireSize);
  const [tireWidthSource, setTireWidthSource] = useState([]);
  const [tireProfileSource, setTireProfileSource] = useState([]);
  const [tireDiameterSource, setTireDiameterSource] = useState([]);
  const [isLoading, setIsLoading] = useState(defaultIsLoading)

  const profileEl = useRef(null);
  const diametertEl = useRef(null);
  const widthEl = useRef(null);
  const {t} = useTranslation(["static-pages", "common"]);

  

  useEffect(() => {
    getTiresWidth().then(({
      data
    }: any) => {
      setIsLoading({ ...isLoading, width: false });
      setTireWidthSource(transform(data));
      if(widthEl?.current) {
        widthEl.current.selectRef.current.focus();
        widthEl.current.selectRef.current.onMenuOpen();
      }
    })
  }, []);

  function handleSelectWidth(width: any) {
    setIsLoading({ ...isLoading, profile: true });
    setSelectedTireSize({ width, profile: undefined, diameter: undefined });
    getProfileByWidth(width).then(({
      data
    }: any) => {
      setIsLoading({ ...isLoading, profile: false });
      setTireProfileSource(transform(data));
      if( profileEl?.current) {
        profileEl.current.selectRef.current.focus();
        profileEl.current.selectRef.current.onMenuOpen();
      }
    })
  }

  function handleSelectProfile(profile: any) {
    setIsLoading({ ...isLoading, diameter: true });
    setSelectedTireSize({ ...selectedTireSize, profile, diameter: undefined })
    getDiameterByWidthProfile(selectedTireSize.width, profile).then(({
      data
    }: any) => {
      setIsLoading({ ...isLoading, diameter: false });
      setTireDiameterSource(transform(data));
      if(diametertEl?.current) {
        diametertEl.current.selectRef.current.focus();
        diametertEl.current.selectRef.current.onMenuOpen();
      }
    })
  }

  function handleSelectDiameter(diameter: any) {
    setSelectedTireSize({ ...selectedTireSize, diameter })
    const tireSize = buildTireSize(selectedTireSize.width, selectedTireSize.profile, diameter);
    handleSizeSelect(tireSize);
  }
  const commonT = (_: string) => t(_, { ns: "common" });


  return (
    <>
      
      <BoxedSelector>
        
        <VehicleSelect
          ref={widthEl}
          className="vehicle-select-year"
          placeholder={commonT("Width (mm)")}
          data={tireWidthSource}
          onSelectItem={handleSelectWidth}
          defaultValue={selectedTireSize.width}
          isLoading={isLoading.width}
          t={commonT}
        />
        
        <VehicleSelect
          ref={profileEl}
          className="vehicle-select-year"
          placeholder={commonT("Profile")}
          data={tireProfileSource}
          onSelectItem={handleSelectProfile}
          defaultValue={selectedTireSize.profile}
          isLoading={isLoading.profile}
          t={commonT}
        />
        
        <VehicleSelect
          ref={diametertEl}
          className="vehicle-select-year"
          placeholder={commonT("Diameter (inches)")}
          data={tireDiameterSource}
          onSelectItem={handleSelectDiameter}
          defaultValue={selectedTireSize.diameter}
          isLoading={isLoading.diameter}
          t={commonT}
        />
      </BoxedSelector>
      
      <HideIf show={calculateSize}>
        
        <PAButton
          type="button"
          onClick={calculateSize}
          buttonType={BUTTON_TYPE.OUTLINE}
          className="d-flex justify-content-center m-t-30"
          disabled={!(selectedTireSize.width && selectedTireSize.profile && selectedTireSize.diameter)}
        >
          {t("CALCULATE")}
        </PAButton>
      </HideIf>
    </>
  );
}

export default BoxedTierSelector;
